import React, { useEffect } from "react";
import { tw } from "@careinfo/tailwind";
import { useForm } from "react-hook-form";
import Button from "../Reusable/Button";
import Card from "../Reusable/Card";
import CodeField from "../Reusable/CodeField";
import Modal from "../Reusable/Modal";
import TextField from "../Reusable/TextInput";
import { Group, Panel, Separator } from "react-resizable-panels";

const EditColumnDefinition = (props:any) => {
 const {
    templateData,
    handleEdit,
    isPatchLoading,
    handleReset,
    isopenWarningPopup,
    setIsOpenWarningPopup,
  } = props;
  console.log("templateData in EditTemplate:", templateData);

  const {
    register,
    formState: { errors },
    handleSubmit,
    setError,
    control,
    watch,
    reset,
  } = useForm({
    defaultValues: {
      name: "",
      slug: "",
      layout: "",
    },
  });

useEffect(() => {
  if (templateData) {
    const rawLayout = templateData?.layout;
    
    let formattedLayout = "";
    if (rawLayout !== null && rawLayout !== undefined) {
      formattedLayout = typeof rawLayout === "object" 
        ? JSON.stringify(rawLayout, null, 2) 
        : rawLayout;
    }

    reset({
      name: templateData?.name || "",
      slug: templateData?.slug || "",
      layout: formattedLayout, 
    });
  }
}, [templateData, reset]);

const editorContent = watch("layout");

  return (
    <>
      <Card>
        <form
          onSubmit={handleSubmit((data: any) => handleEdit(data, setError))}
          autoComplete={"off"}
          className={tw`flex flex-col gap-y-6`}
        >
          <div className={tw`flex gap-x-4`}>
            <TextField
              register={register("name")}
              label={"Name"}
              errors={errors?.name}
            />
            <TextField
              register={register("slug")}
              label={"Slug"}
              errors={errors?.slug}
            />
          </div>

          <div>
            <div className={tw`flex justify-between items-center mb-2`}>
              <label className={tw`font-semibold text-gray-700`}>
               Layout
              </label>
              {/* <button
                type="button"
                className={tw`text-sm text-blue-600 hover:underline`}
                onClick={() => setIsOpenWarningPopup(true)}
              >
                Reset to Default
              </button> */}
            </div>

            <Group
              orientation="horizontal"
              className={tw`h-[500px] border rounded-lg overflow-hidden`}
            >
              <Panel defaultSize={50} minSize={30}>
                {/* Editor field */}
                <CodeField
                  control={control}
                  name="layout"
                  language="json"
                />
              </Panel>

              <Separator
                className={tw`w-[2px] bg-gray-200 cursor-col-resize`}
              />

              {/* <Panel defaultSize={50} minSize={30}>
                <div className={tw`h-full p-4 bg-gray-50 overflow-auto`}>
                  <p className={tw`text-[10px] font-bold text-gray-400 mb-2`}>
                    JSON PREVIEW
                  </p>
                  <pre className={tw`text-xs font-mono text-blue-800`}>
                    {editorContent}
                  </pre>
                </div>
              </Panel> */}
            </Group>
          </div>

          <div className={tw`flex justify-end`}>
            <div className={tw`w-32`}>
              <Button
                label={"Update"}
                isLoading={isPatchLoading}
                type="submit"
              />
            </div>
          </div>
        </form>
      </Card>

      <Modal isOpen={isopenWarningPopup} setIsOpen={setIsOpenWarningPopup}>
        <div className="flex flex-col items-center p-6">
          <p className="font-semibold text-gray-800 text-lg">
            Reset to Default?
          </p>
          <div className={tw`flex gap-x-4 mt-8`}>
            <Button type="button" label={"Yes"} onClick={handleReset} />
            <Button
              type="button"
              label={"Cancel"}
              className={tw`bg-gray-100 text-black`}
              onClick={() => setIsOpenWarningPopup(false)}
            />
          </div>
        </div>
      </Modal>
    </>
  );
}

export default EditColumnDefinition